"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityColor = exports.EntityCategory = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["APP"] = "app";
    EntityType["CONTAINER_DEPOT_TOKEN"] = "container-depot-token";
    EntityType["DEPLOY_CONFIG"] = "deploy-config";
    EntityType["EGRESS_TOKEN"] = "egress-token";
    EntityType["ORG"] = "org";
    EntityType["PLAN"] = "plan";
    EntityType["DEVELOPER"] = "platform-user";
    EntityType["DEVELOPER_INVITE"] = "developer-invite";
    EntityType["ROLE"] = "role";
    EntityType["ROLE_POLICY"] = "role-policy";
    EntityType["SCOPED_POLICY"] = "scoped-policy";
    EntityType["SCOPED_TOKEN"] = "scoped-token";
    EntityType["SCOPED_TOKEN_POLICY"] = "scoped-token-policy";
    EntityType["UNSCOPED_POLICY"] = "unscoped-policy";
    EntityType["UNSCOPED_TOKEN"] = "unscoped-token";
    EntityType["UNSCOPED_TOKEN_POLICY"] = "unscoped-token-policy";
    EntityType["USER_POLICY"] = "user-policy";
    EntityType["USER_ROLE"] = "user-role";
    EntityType["WEB_CONTAINER"] = "web-container";
})(EntityType || (exports.EntityType = EntityType = {}));
var EntityCategory;
(function (EntityCategory) {
    EntityCategory["HUB"] = "hub";
    EntityCategory["TOKENS"] = "tokens";
})(EntityCategory || (exports.EntityCategory = EntityCategory = {}));
exports.EntityColor = {
    [EntityType.APP]: '#ff7043',
    [EntityType.CONTAINER_DEPOT_TOKEN]: '#4db5ff',
    [EntityType.DEPLOY_CONFIG]: 'white',
    [EntityType.EGRESS_TOKEN]: 'rgb(0,192,255)',
    [EntityType.ORG]: 'rgb(219,106, 128 )',
    [EntityType.PLAN]: 'rgb(255,236,0)',
    [EntityType.DEVELOPER]: '#9370db',
    [EntityType.DEVELOPER_INVITE]: '#ad65e1',
    [EntityType.ROLE]: 'pink',
    [EntityType.ROLE_POLICY]: '#ff5722', // Journey style guide orange
    [EntityType.SCOPED_POLICY]: '#ff7043',
    [EntityType.SCOPED_TOKEN]: 'rgb(192, 255, 0)',
    [EntityType.UNSCOPED_POLICY]: '#ff7043'
};
